import React, { PureComponent } from 'react';
import {
  Box,
  Paper,
  TextField,
  FormLabel,
  Grid,
  Select,
  OutlinedInput,
  MenuItem,
  FormControl,
  InputLabel,
} from '@material-ui/core';

class Budget extends PureComponent {
  render() {
    const { currency, minSalary, maxSalary, onChange, salaryTime } = this.props;

    return (
      <Paper square elevation={0} className="budget" id="budget">
        {/* <Box pb="18px">
          <Typography variant="body1" className="font-weight-500">
            Budget
          </Typography>
        </Box> */}
        <Box>
          <Box p="15px 0">
            <FormLabel component="legend">Salary Range</FormLabel>
          </Box>
          <Grid container spacing={2} justify="center">
            <Grid item xs={3}>
              <TextField
                name="minSalary"
                label="Min"
                placeholder="Min"
                margin="normal"
                variant="outlined"
                value={minSalary}
                onChange={onChange}
                autoComplete={'off'}
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                name="maxSalary"
                label="Max"
                placeholder="Max"
                margin="normal"
                variant="outlined"
                value={maxSalary}
                onChange={onChange}
                autoComplete={'off'}
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <FormControl variant="outlined" fullWidth margin="normal">
                <InputLabel htmlFor="currency" className="select-label">
                  Currency
                </InputLabel>
                <Select
                  value={currency}
                  onChange={onChange}
                  fullWidth
                  input={
                    <OutlinedInput name="currency" id="currency" fullWidth />
                  }
                >
                  <MenuItem value={'INR'}>INR</MenuItem>
                  <MenuItem value={'USD'}>$</MenuItem>
                  <MenuItem value={'EUR'}>EUR</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              <FormControl variant="outlined" fullWidth margin="normal">
                <InputLabel htmlFor="salaryTime" className="select-label">
                  Time
                </InputLabel>
                <Select
                  value={salaryTime}
                  onChange={onChange}
                  fullWidth
                  input={
                    <OutlinedInput
                      name="salaryTime"
                      id="salaryTime"
                      fullWidth
                    />
                  }
                >
                  <MenuItem value={'perHour'}>Per Hour</MenuItem>
                  <MenuItem value={'perAnnum'}>Per Annum</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    );
  }
}

export default Budget;
